import * as R from "ramda";
import React, {Component} from "react";
import FlexView from "react-flexview";
import Container from "../../../modules/commons/Container";
import ModalContainer from "../../../modules/commons/ModalContainer";
import SimpleButton from "../../../modules/commons/SimpleButton";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import SimpleInput from "../../../modules/SimpleInput";
import Api from "../../../Services/Api";
import {HttpStatus, Status} from "../../common/Constants";
import AccessMenuSettingTree from "./accessMenuSettingTree";
import {fetchDataAsync} from "../../../Services/Utils";
import {defaultTableChange} from "../../../modules/custom/customTable";
import SimpleAlert from "../../../modules/popup/SimpleAlert";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import ToggleButton from "react-toggle-button";

class AccessMenuSetting extends Component {
    tableColumns = [
        {
            name: "",
            label: "No",
            options: {
                customBodyRender: (_, tableMeta) => {
                    const {page, rowsPerPage} = tableMeta.tableState;
                    
                    const viewIndex = (tableMeta.rowIndex + 1) - rowsPerPage > 0 ? tableMeta.rowIndex - rowsPerPage : tableMeta.rowIndex 
                    const rowNumber = page * rowsPerPage + (viewIndex + 1);

                    return <>{rowNumber}</>;
                },
            },
        },
        {
            name: "roleName",
            label: "Nama Role",
            options: {
                setCellProps: () => ({
                    style: {width: "100%"},
                }),
            },
        },
        {
            name: "superAccess",
            label: "Super Access",
            options: {
                customBodyRender: (val, {rowIndex}) => {
                    const disabled = this.props.auth?.user?.username !== 'admin'
                    return (
                    <ToggleButton 
                        value={val}
                        thumbStyle={{
                          opacity: disabled ? 0.5 : 1,
                          cursor: disabled ? "not-allowed" : "pointer",
                        }}
                        trackStyle={{
                          opacity: disabled ? 0.5 : 1,
                          cursor: disabled ? "not-allowed" : "pointer",
                        }}
                        onToggle={(value)=> {
                            if(disabled) return
                            this.handleToggleSuperAccess(rowIndex, !value)
                        }}
                    />
                )
                }
            },
        },
        {
            name: "id",
            label: "Aksi",
            options: {
                customBodyRender: (val, {rowIndex}) => (
                    <FlexView vAlignContent="center">
                        <SimpleButton onClick={() => this.handleModifyingModalVisibility(rowIndex)}>
                            Copy
                        </SimpleButton>
                        <SimpleButton onClick={() => this.handleAccessMenuModalVisibility(rowIndex)}>
                            Hak Akses
                        </SimpleButton>
                        <SimpleButton onClick={() => this.handleDelete(val)}>Hapus</SimpleButton>
                    </FlexView>
                ),
                sort: false,
            },
        },
    ];

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            inputValue: null,
            modifyingVisible: false,
            accessMenuVisible: false,
            selectedData: null,
            errorMessage: null,
            dataTable: [],
            masterUserInputValue: null,
            isFetch: false,
            errorDuplicateName: false,
            pagination: {
                page: 1,
                limit: 5,
                totalData: 0,
            },
            alert: {
                visible: false,
                content: null,
                title: null
            }
        };
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        await this.fetchData();
        this.handleTriggerLoading();
    }

    handleTriggerLoading = () => {
        this.setState((prevState) => ({...prevState, loading: !prevState.loading}));
    };

    fetchData = async () => {
        let res = await this.callApi(
            Api.create("NAGAMAS_AUTH").getAllMasterRole,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                dataTable: res.data.data,
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.data.length,
                }
            }));
        }
    };

    handleAlertVisibility = (title , content) => {
        this.setState(prev=>({
            ...prev,
            alert:{
                visible: !prev.alert.visible,
                content: content || null,
                title: title || null
            }
        }))
    }

    handleDelete = async (id) => {
        this.handleTriggerLoading();
        const isCanDelete = await this.handleValidateDelete(id);
        if (!isCanDelete) {
          this.handleTriggerLoading();
          return this.handleAlertVisibility(
            "Peringatan",
            "Data tidak dapat dihapus karena masih digunakan oleh user lain. Silakan cek kembali!",
          );
        }
        let res = await this.callApi(
            Api.create("NAGAMAS_AUTH").deleteMasterRole,
            id,
        );
        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            await this.fetchData();
        }
        this.handleTriggerLoading();
    };

    handleValidateDelete = async (id) => {
        const res = await this.callApi(
          Api.create("NAGAMAS_AUTH").checkDeleteMasterRole,
          {
            id: id,
          },
        );
        return res?.data?.data?.canDelete
    }

    handleModifyingModalVisibility = async (index) => {
        if (!R.isNil(index)) {
            const selectedData = this.state.dataTable[index];
            let response = await this.callApi(
                Api.create("NAGAMAS_AUTH").getMasterRoleMenuById,
                selectedData.id,
            );
            if (response.ok && response.data.status === HttpStatus.SUCCESS) {
                selectedData.roleMenu = {
                    idRole: null,
                    listMenu: response.data.data.map((value) => ({
                        id: null,
                        idMenu: value.idMenu,
                        createAccess: value.createAccess,
                        updateAccess: value.updateAccess,
                        deleteAccess: value.deleteAccess,
                    })),
                };
                this.setState((prevValue) => ({
                    ...prevValue,
                    modifyingVisible: !prevValue.modifyingVisible,
                    selectedData: selectedData,
                    inputValue: prevValue.dataTable[index].roleName,
                    errorMessage: null,
                }));
            }
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                modifyingVisible: !prevValue.modifyingVisible,
                selectedData: null,
                inputValue: null,
                errorMessage: null,
            }));
        }
    };

    handleValueChange = ({target}) => {
        this.setState((prevValue) => ({
            ...prevValue,
            inputValue: target.value.toUpperCase(),
        }));
    };

    handleSubmit = async (e) => {
        this.handleTriggerLoading();
        e.preventDefault();

        if (!this.state.inputValue) {
            this.setState((prevValue) => ({
                ...prevValue,
                errorMessage: "Field belum diisi",
                loading: false,
            }));
            return;
        } else {
            this.setState((prevValue) => ({
                ...prevValue,
                errorMessage: null,
            }));
        }

        // todo adjustment after done dev from back-end
        // this.handleTriggerLoading();
        // return this.handleErrorDuplicateName();


        let request = {
            id: null,
            roleName: this.state.inputValue,
            status: Status.ACTIVE,
        };
        let api;
        api = Api.create("NAGAMAS_AUTH").createMasterRole;
        if (!R.isNil(this.state.selectedData)) {
            request.status = this.state.selectedData.status;
            request.roleMenu = this.state.selectedData.roleMenu;
        }
        let res = await this.callApi(api, request);

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.handleModifyingModalVisibility();
            await this.fetchData();
        } else if (res.ok && res.data.status === HttpStatus.FAILED && res.data.code === 210) {
            this.handleErrorDuplicateName();
        }

        this.handleTriggerLoading();
    };

    handleAccessMenuModalVisibility = async (index) => {
        let {isFetch} = this.state;
        this.handleTriggerLoading();
        if (!R.isNil(index)) {
            this.setState((prevValue) => ({
                ...prevValue,
                selectedData: {...prevValue.dataTable[index]},
                accessMenuVisible: !prevValue.accessMenuVisible,
            }));
        } else {
            if (isFetch) {
                await this.fetchData();
            }
            this.setState((prevValue) => ({
                ...prevValue,
                accessMenuVisible: !prevValue.accessMenuVisible,
                isFetch: false,
            }));
        }
        this.handleTriggerLoading();
    };

    handleTriggerFetch = () => {
        this.setState((prevValue) => ({...prevValue, isFetch: !prevValue.isFetch}));
    };

    callApi = async (api, args) => {
        return await fetchDataAsync({
            asyncFn: api,
            menuName: "Setting Hak Akses",
            setError: this.props.setError,
            args: args,
        })
    };

    handleErrorDuplicateName = () => {
        this.setState((prevValue) => ({...prevValue, errorDuplicateName: !prevValue.errorDuplicateName}));
    }

    handleToggleSuperAccess = async (index, value) => {
        this.handleTriggerLoading();
        const selectedData = this.state.dataTable[index];
        const res = await Api.create("NAGAMAS_AUTH").updateSuperAccess({
            id: selectedData?.id || null,
            superAccess: value
        })

        if(res.ok && res.data.status === HttpStatus.SUCCESS){
            await this.fetchData();
        }
        this.handleTriggerLoading();
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: tableState.page + 1,
            }
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination:{
                ...prevValue.pagination,
                page: 1,
                limit: tableState.rowsPerPage,
            }
        }));
    };

    render() {
        let {pagination} = this.state;
        return (
            <>
                <Container>
                    <SimpleDataTable
                        key={`${pagination.totalData}-${pagination.page}`}
                        data={this.state.dataTable}
                        columns={this.tableColumns}
                        toCount={pagination.totalData}
                        rowsPerPage={pagination.limit}
                        page={pagination.page - 1}
                        options={{
                            ...defaultTableChange(this.handleChangePage, this.handleRowsPerPage),
                            serverSide: false
                        }}
                        footerAdditionalButtons={
                            <SimpleButton onClick={() => this.handleModifyingModalVisibility()}>
                <span>
                  <i className="fa fa-plus margin-right-10px"></i>
                </span>
                                Tambah
                            </SimpleButton>
                        }
                    />
                </Container>
                {this.state.modifyingVisible && (
                    <SimpleModal
                        visible={this.state.modifyingVisible}
                        onClickClose={() => this.handleModifyingModalVisibility()}
                        content={
                            <ModalContainer>
                                <form onSubmit={this.handleSubmit}>
                                    <SimpleInput
                                        id="input_text_nama_hak_akses"
                                        name="roleName"
                                        label="Nama Hak Akses"
                                        mandatory
                                        errorMessage={this.state.errorMessage}
                                        value={this.state.inputValue}
                                        onChange={this.handleValueChange}
                                    />
                                    <div style={{textAlign: "center"}}>
                                        <SimpleButton type="submit">SIMPAN</SimpleButton>
                                    </div>
                                </form>
                            </ModalContainer>
                        }
                    />
                )}
                {this.state.accessMenuVisible && (
                    <AccessMenuSettingTree
                        setError={this.props.setError}
                        data={this.state.selectedData}
                        visible={this.state.accessMenuVisible}
                        onClickClose={() => this.handleAccessMenuModalVisibility()}
                        triggerFetch={this.handleTriggerFetch}
                    />
                )}
                {this.state.errorDuplicateName && (
                    <SimpleAlert
                        visible={this.state.errorDuplicateName}
                        title={"Information"}
                        content={"Nama Role sudah tersedia didalam list monitoring. Mohon dicek kembali!"}
                        onClickClose={this.handleErrorDuplicateName}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={this.handleErrorDuplicateName}
                            />
                        }
                    />
                )}
                {this.state.alert.visible && (
                    <SimpleAlert
                        visible={this.state.alert.visible}
                        title={this.state.alert.title}
                        content={this.state.alert.content}
                        onClickClose={()=> this.handleAlertVisibility()}
                        additionalButtons={
                            <SimpleButton
                                type="button"
                                text="OK"
                                onClick={() => this.handleAlertVisibility()}
                            />
                        }
                    />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapStateToProps = state => {
  return {
    auth: state.auth
  }
}


const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AccessMenuSetting);
